// extracted by mini-css-extract-plugin
export var arrow = "_3n-6";
export var changeItem = "_3n-3";
export var changesHeader = "_3n-1";
export var changesList = "_3n-2";
export var container = "_3n-0";
export var pathLabel = "_3n-4";
export var value = "_3n-7";
export var valuesContainer = "_3n-5";